import { takeLatest, put, all } from "redux-saga/effects";
import { toast } from "react-toastify";
import history from "../../../services/history";
import HttpService from "../../../services/HttpService";

import {
	changeLoading,
	validateTokenConfirmPhoneSuccess,
	validateTokenConfirmPhoneError,
	failPincodeNewAccount,
	respSendRegisterCelPhone,
	respResendPhoneConfirmation,
} from "./actions";

export function* validateTokenConfirmPhone({ payload }) {
	try {
		const { token, withRedirect } = payload;
		yield put(failPincodeNewAccount(false));

		const response = yield HttpService.tokenConfirmation(token);

		if (!response.success) {
			yield put(failPincodeNewAccount(true));
			toast.error("Token inválido.");
		}
		yield put(changeLoading(false));

		if (response.success && !withRedirect) {
			history.push("/onboard/cadastro-trademap");
		} else {
			yield put(validateTokenConfirmPhoneSuccess(response));
		}
	} catch (err) {
		let message = err.message || "Não foi possível efetuar a validação do token.";
		toast.error(message);
		yield put(changeLoading(false));
		yield put(validateTokenConfirmPhoneError(err));
	}
}

export function* sendToken({ payload }) {
	try {
		const { vl_full_phone_number } = payload;
		const response = yield HttpService.reSendPhone(vl_full_phone_number);
		if (!response.success) {
			throw response.message || "Ocorreu um erro, entre em contato com o administrador.";
		}

		sessionStorage.setItem("vl_full_phone_number", vl_full_phone_number);
		toast.success("Código reenviado com sucesso.");

		yield put(respResendPhoneConfirmation(response.result.validation));
		yield put(changeLoading(false));
	} catch (err) {
		let message = err.message || "Não foi possível efetuar a validação do token.";
		toast.error(message);
		yield put(changeLoading(false));
	}
}

export function* sendRegisterCelPhone({ payload }) {
	try {
		const { cd_access_token, vl_full_phone_number, operation_system, type_to_send } = payload;
		const resp = yield HttpService.registerCelPhone(
			cd_access_token,
			vl_full_phone_number,
			operation_system,
			type_to_send
		);

		if (!resp.success)
			return toast.error(
				resp.message || "Ocorreu um erro, entre em contato com o administrador."
			);

		yield put(respSendRegisterCelPhone(resp.result));
		return toast.success("Código reenviado com sucesso.");
	} catch (error) {
		let message = error.message || "Não foi possível efetuar a validação do token.";
		toast.error(message);
	}
}

export default all([
	takeLatest("@confirmToken/VALIDATE_TOKEN_CONFIRM_PHONE_REQUEST", validateTokenConfirmPhone),
	takeLatest("@confirmToken/SEND_TOKEN_REQUEST", sendToken),
	takeLatest("@confirmToken/SEND_REGISTER_CEL_PHONE", sendRegisterCelPhone),
]);
